<template>
    <div>
        <trax-ui-ajax-simple-table 
            :id="id" :header="header" :header-color="headerColor"
            :endpoint="endpoint" :endpoint-params="endpointParams" :rows="rows" :cols="cols" :bus="bus">
        </trax-ui-ajax-simple-table>
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-flight-follow-up'},
            header: { default: 0 },
            headerColor: { default: 'primary' },
            facesFolder: {default: app_url},
            facesDefault: {default: 'polaris/img/lib/misc/avatar.jpg'}
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                grade_select: data.grade_select,
                endpoint: app_url+'polaris/api/front/registrations/'+data.registration.id,
                endpointParams: {
                    accessors: ['members']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id+'/learners',
                registration: data.registration,
                item: data.item,
                learning_unit_dashboard_routes: data.learning_unit_dashboard_routes,
                cols: [
                    {width: '50px'},
                    {},
                    {class: 'text-center'},
                    {class: 'text-right'}
                ],
                learners : null,
                states : null,
                rows: [],
                bus: this.$bus
            }
        },

        computed: {

            editDashboardPermission: function() {
                return this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations'];
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.getStates();
        },
        
        methods: {
        
            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.setStates(response.data.data);
                    })
                    .catch(function (error) {
                    });
            },
            
            setData(data) {
                var learners = data.data.members;
                learners.sort(function(a, b) {
                    if (a.lastname < b.lastname) return -1;
                    if (a.lastname > b.lastname) return 1;
                    return 0;
                });
                this.learners = learners;
                if (this.states) this.updateRows();
           },

            setStates(states) {
                this.states = states;
                if (this.learners) this.updateRows();
            },

            updateRows() {
                this.rows = [];
                for (var index in this.learners) {
                    var learner = this.learners[index];
                    this.rows.push([
                        this.picture(learner),
                        this.name(learner),
                        this.success(learner),
                        this.validation(learner)
                    ]);
                }
            },

            
            //------------------------------- Columns rendering ----------------------------//


            picture(learner) {
                var src = learner.avatar ? learner.avatar : this.facesFolder + this.facesDefault;
                var html = '<img src="'+src+'" class="avatar">'
                return this.link(learner, html);
            }, 

            name(learner) {
                var html = '<span class="font-weight-bold">'+learner.lastname + ' ' + learner.firstname+'</span>';
                var entity = '';
                if (learner.entity) entity = learner.entity.name;
                if (learner.subentity) entity += ' / ' + learner.subentity.name;
                html += '<br><small>'+entity+'</small>';
                return this.link(learner, html);
            },

            success(learner) {
                var state = this.states[learner.id];
                if (!state || state.grade == undefined) return '';
                var color = state.color_status ? state.color_status : 'default';
                var result = state.grade + '/' + this.grade_select.length;
                var html = '<button class="btn btn-sm btn-'+color+'" style="min-width:55px;">' + result + '</button>';
                return this.link(learner, html);
            },

            validation(learner) {
                var state = this.states[learner.id];
                if (!state) return '';
                var html = '';
                if (state.validation) html += this.validationHtml(state.validation);
                if (state.learner_validation) html += this.validationHtml(state.learner_validation, true);
                if (state.third_validation) html += this.validationHtml(state.third_validation, true);
                return this.link(learner, html);
            },

            validationHtml(validation, newLine) {
                var html = newLine ? '<br>' : '';
                html += '<small><i class="material-icons" style="position:relative !important;top:-1px !important;">done</i> ' + validation.user_name + '</small>';
                return html;
            },

            link: function(learner, content) {
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[this.item.type]+'/registration/'+this.registration.id+'/'+this.item.type+'/'+this.item.id+'/learner/' + learner.id;
                // Check permissions
                var state = this.states[learner.id];
                if (!state || !state.validation) {
                    if (this.editDashboardPermission) href += '/edit';
                    else return content;
                }
                return '<a href="'+href+'">'+content+'</a>';
            }
        }
    }
</script>
